import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

class HttpInterceptorHandler implements HttpHandler {
	constructor(
		private next: HttpHandler,
		private interceptor: HttpInterceptor
	) {}

	handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
		return this.interceptor.intercept(req, this.next);
	}
}

@Injectable({
	providedIn: "root",
})
export class LazyInterceptorService implements HttpInterceptor {
	/**
	 * It is needed due to interceptors limitation:
	 * Because interceptors are (optional) dependencies of the HttpClient service, you must provide them in the same injector
	 * (or a parent of the injector) that provides HttpClient. Interceptors provided after DI creates the HttpClient are ignored.
	 * With it we can add interceptors from lazyloaded modules
	 */

	private interceptors: HttpInterceptor[] = [];

	registerHandler(interceptor: HttpInterceptor) {
		if (this.interceptors.indexOf(interceptor) === -1) {
			this.interceptors.push(interceptor);
		}
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (this.interceptors.length) {
			return this.interceptors
				.reduceRight((n, interceptor) => new HttpInterceptorHandler(n, interceptor), next)
				.handle(req);
		}
		return next.handle(req);
	}
}
